export enum HomepageEnum {
  TCB = 'https://www.texascapitalbank.com/',
  TCB_PRODUCT_SELECTION = 'https://www.texascapitalbank.com/personal-banking/',
  BASK = 'https://www.baskbank.com/',
  BASK_PRODUCT_SELECTION = 'https://www.baskbank.com/products'
}
